import React from 'react';
import ReactSelect from 'react-select';

var CurrentUser = require("lib/account/CurrentUser");
var AccountPlans = require("lib/account/AccountPlans");

var Modal = require("components/utility/AltModal");

require("appdev/wizards/add_new_admin_modal.scss");

class AddNewAdminModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            username: '',
            password: '',
            googleSSOId: '',
            cleverUserId: '',
            primaryStudentLists: [],
            secondaryStudentLists: [],
            studentListOptions: [],
            sendWelcomeEmail: false,
            createUpgradeToken: false,
            isPrimaryAdmin: false,
            tokenStartDate: '',
            tokenPlanType: {},
            gradeLevel: {},
            product: {},
            role: {},
            addToStudentLists: false,
            licenseClasses: 0
        };
    }

    /////// HELPERS ///////

    districtOrgPage() {
        return this.props.districtOrg ? true : false
    }

    isTeacher() {
        var { role } = this.state
        return !_.isEmpty(role) && role.value == TEACHER_ROLE
    }

    isSchoolAdmin() {
        var { role } = this.state
        return !_.isEmpty(role) && role.value == ADMIN_ROLE
    }

    isDistrictAdmin() {
        var { role } = this.state
        return !_.isEmpty(role) && role.value == DISTRICT_ADMIN_ROLE
    }

    getOrgIDParam() {
        var { schoolOrg, districtOrg } = this.props
        
        if (schoolOrg) {
            var param = { school_org_id: schoolOrg.id }

            if (schoolOrg.districtOrg && !_.isEmpty(schoolOrg.districtOrg)) {
                param['district_org_id'] = schoolOrg.districtOrg.id
            }

            return param
        } else if (districtOrg) {
            return { district_org_id: districtOrg.id }
        }
    }

    // returns all plan type options
    getPlanTypeOptions() {
        return _.map(AccountPlans.PAID_PLANS, p => { return { value: p, label: p } })
    }

    // returns all product options in a format for a select field
    getGradeLevelOptions() {
        return _.map(_.values(ALL_GRADES), p => { return { value: p, label: p } })
    }

    // returns all role options in a format for a select field
    getRoleOptions() {
        if (this.districtOrgPage()) {
            return [{ value: DISTRICT_ADMIN_ROLE, label: DISTRICT_ADMIN_ROLE }]
        } else {
            return _.map([TEACHER_ROLE, ADMIN_ROLE], r => {
                return { value: r, label: r }
            })
        }
    }

    // returns non-primary student list options in a format for a select field
    getSecondaryStudentListOptions() {
        var { studentListOptions, primaryStudentLists } = this.state

        if (!_.isEmpty(studentListOptions)) {
            return _.filter(studentListOptions, (sl) => { return !_.include(primaryStudentLists, sl) })
        }
    }

    getValue(obj, v) {
        return (!_.isEmpty(obj) && _.has(obj, v)) ? obj[v] : null
    }

    // displays alert
    alertUser(alert) {
        window.wrNotifications.triggerDropDownNotification({
            text: alert,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    // validate input
    validateInput() {
        var { primaryStudentLists, secondaryStudentLists,
            createUpgradeToken, tokenPlanType, tokenStartDate,
            licenseClasses, addToStudentLists } = this.state
        
        // validate required fields
        var requiredInputs = _.compact(_.map(REQUIRED_FIELDS, f => {
            if (this.state[f] && !_.isEmpty(this.state[f])) {
                return this.state[f]
            }
        }))

        if (_.size(requiredInputs) != _.size(REQUIRED_FIELDS)) {
            return 'First name, last name, email, username, role, and password are required'
        }

        if (this.isTeacher()) {
            // teachers must have a student list selected
            if (addToStudentLists && (_.isEmpty(primaryStudentLists) && _.isEmpty(secondaryStudentLists))) {
                return 'Teachers must be added student lists or create a new one'
            }
        }

        // upgrade tokens must have plan type and start date
        if (createUpgradeToken) {
            if (_.isEmpty(tokenPlanType) || _.isEmpty(tokenStartDate)) {
                return 'Upgrade tokens must have a plan type and start date'
            }

            if (this.isTeacher() && licenseClasses < 1) {
                return 'Teachers must have at least 1 liscensed class'
            }
        }
    }

    // assign signup_type based on role
    // this must align with the backend, so check the AdminCreator l2e before modifying
    getSignupType() {        
        if (this.isTeacher()) { return 'class' }
        if (this.isSchoolAdmin() || this.isDistrictAdmin()) { return 'school' }
    }

    // puts state data in correct format to send with API
    formatPostData() {
        var postData = {
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
            sign_in_email: this.state.email,
            username: this.state.username,
            double_password: this.state.password,
            google_sso_id: this.state.googleSSOId,
            clever_id: this.state.cleverUserId,
            primary_student_lists: _.pluck(this.state.primaryStudentLists, 'value') || null,
            secondary_student_lists: _.pluck(this.state.secondaryStudentLists, 'value') || null,
            send_welcome_email: this.state.sendWelcomeEmail,
            create_upgrade_token: this.state.createUpgradeToken,
            grade_level: this.getValue(this.state.gradeLevel, 'value'),
            role: this.getValue(this.state.role, 'value'),
            add_to_existing_student_lists: this.state.addToStudentLists,
            token_plan_type: this.getValue(this.state.tokenPlanType, 'value'),
            token_start_date: this.state.tokenStartDate,
            license_classes: this.state.licenseClasses,
            is_primary: this.state.isPrimaryAdmin
        };

        // remove all empty key, value pairs
        return _.omit(postData, (value) =>
                value === null ||
                value === 0 ||
                value === '' ||
                value === false ||
                (typeof value === 'object' && Object.keys(value).length === 0) ||
                (Array.isArray(value) && value.length === 0)
        );
    }

    //////// MODAL CONTROLS ACTIONS ///////

    show() {
        this.refs.modal.show();
    }

    //////// STATE MANIPULATORS ////////

    setStudentListOptions() {
        var { schoolOrg } = this.props
        if (!_.isEmpty(schoolOrg) && _.size(schoolOrg.student_lists)) {
            var studentListOptions =  _.map(_.where(schoolOrg.student_lists, { inactive: null }), (sl) => {
                return { value: sl.id, label: sl.name }
            })

            this.setState({ studentListOptions })
        }  
    }

    setProduct() {
        var { schoolOrg, districtOrg } = this.props

        if (!_.isEmpty(schoolOrg) && !_.isEmpty(schoolOrg.primary_admin)) { 
            var product = schoolOrg.primary_admin.product
            this.setState({ product: { value: product, label: product } })
        } else if (!_.isEmpty(districtOrg) && !_.isEmpty(districtOrg.primary_admin)) {
            var product = districtOrg.primary_admin.product
            this.setState({ product: { value: product, label: product } })
        }
    }

    setRole(roleSelection) {
        if (this.districtOrgPage()) {
            // district org admins must be created with an upgrade code
            this.setState({ role: { value: DISTRICT_ADMIN_ROLE, label: DISTRICT_ADMIN_ROLE }, createUpgradeToken: true})
        } else if (roleSelection) {
            // school and district admins must be created with upgrade tokens
            if (roleSelection.value == DISTRICT_ADMIN_ROLE || roleSelection.value == ADMIN_ROLE) {
                this.setState({ role: roleSelection, primaryStudentLists: [], secondaryStudentLists: [], createUpgradeToken: true })
            } else {
                this.setState({ role: roleSelection, primaryStudentLists: [], secondaryStudentLists: [] })
            }
        }
    }

    ////////////// SUBMIT ACTION //////////////
    handleSubmit(e) {
        $wr.nope(e)

        // validate input
        var validationAlert = this.validateInput()

        if (!_.isEmpty(validationAlert)) {
            return this.alertUser(validationAlert)
        }

        // assign signup_type based on role
        var signupType = this.getSignupType()

        CurrentUser.api().postAdmins({ admin: { ...this.formatPostData() }, ...this.getOrgIDParam(), signup_type: signupType }, $wr.apiHandler((res) => {
            if (res.errors) {
                this.alertUser(res.errors.join(' & '))
            } else {
                window.wrNotifications.triggerDropDownNotification({
                    title: "Admin Created", icon: "ok-sign"
                });

                setTimeout(() => { window.location.reload() }, 1000);
            }
        }));
    }

    ////////////// RENDER METHODS //////////////

    // if creating with upgrade token, render additional options
    renderUpgradeCodeInputFields() {
        var { createUpgradeToken, tokenStartDate } = this.state

        if (this.districtOrgPage() || this.isDistrictAdmin() || this.isSchoolAdmin()) {
            var input = <input data-lpignore="true" type="checkbox" className="form-control" checked={true} disabled={true} />    
        } else {
            var input = (
                <input data-lpignore="true" type="checkbox" className="form-control" value={this.state.createUpgradeToken} checked={this.state.createUpgradeToken}
                    onChange={() => this.setState({ createUpgradeToken: !this.state.createUpgradeToken, tokenPlanType: {}, tokenStartDate: null, licenseClasses: 0 })} />
            )
        }

        return (
            <React.Fragment>
                <div className="inputContainer">
                    <div className='inputLabel'>Create w/ Upgrade Token:</div>
                    {input}
                </div>
                {createUpgradeToken && (
                    <React.Fragment>
                        <div className="inputContainer childInput">
                            <div className='inputLabel'>Start Date:</div>
                            <input data-lpignore="true" type='date' className="form-control" value={tokenStartDate}
                                onChange={(e) => this.setState({ tokenStartDate: e.target.value })} />
                        </div>
                        <div className="inputContainer childInput">
                            <div className='inputLabel'>Plan Type:</div>
                            <ReactSelect name="tokenPlanType" value={this.state.tokenPlanType}
                                options={this.getPlanTypeOptions()} onChange={(pt) => this.setState({ tokenPlanType: pt })} />
                        </div>
                        {this.isTeacher() && (
                            <div className="inputContainer childInput">
                                <div className='inputLabel'># of License Classes:</div>
                                <input data-lpignore="true" type="number" className="form-control" value={this.state.licenseClasses}
                                    onChange={(e) => this.setState({ licenseClasses: e.target.value })} />
                            </div>
                        )}
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }

    // if creating a teacher, render student list selectors
    renderTeacherInputFields() {
        var { role, primaryStudentLists, studentListOptions, addToStudentLists, secondaryStudentLists } = this.state

        if (_.isEmpty(role) || role.value !== TEACHER_ROLE) { return null }
        
        return (
            <React.Fragment>
                <div className="inputContainer">
                    <div className='inputLabel'>Add to Existing Student Lists?</div>
                    <input data-lpignore="true" type="checkbox" className="form-control" value={addToStudentLists}
                        onChange={() => this.setState({ addToStudentLists: !addToStudentLists, primaryStudentLists: [], secondaryStudentLists: [] })} />
                </div>
                {addToStudentLists && (
                    <React.Fragment>
                        <div className="inputContainer childInput">
                            <div className='inputLabel'>Primary Student Lists:</div>
                            <ReactSelect name="primaryStudentLists" value={primaryStudentLists}
                                options={studentListOptions} multi={true} joinValues={true}
                                delimiter="," onChange={(sls) => this.setState({ primaryStudentLists: sls, secondaryStudentLists: [] })} />
                        </div>
                        <div className="inputContainer childInput extraBottomMargin">
                            <div className='inputLabel'>Secondary Student Lists:</div>
                            <ReactSelect name="secondaryStudentLists" value={secondaryStudentLists}
                                options={this.getSecondaryStudentListOptions()} multi={true} joinValues={true}
                                delimiter="," onChange={(sls) => this.setState({ secondaryStudentLists: sls })} />
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }

    // if adding to clever user, allow wizard to send welcome email
    renderCleverInputFields() {
        var { cleverUserId } = this.state
        
        if (cleverUserId) {
            return (
                <React.Fragment>
                    <div className="inputContainer childInput">
                        <div className='inputLabel'>Send Welcome Email:</div>
                        <input data-lpignore="true" type="checkbox" className="form-control" value={this.state.sendWelcomeEmail}
                            onChange={() => this.setState({ sendWelcomeEmail: !this.state.sendWelcomeEmail })} />
                    </div>
                </React.Fragment>
            )
        }
    }

    // renders all inputs
    renderInputFields() {
        return (
            <React.Fragment>
                <div className="inputContainer">
                    <div className='inputLabel'>First Name:</div>
                    <input data-lpignore="true" className="form-control" value={this.state.firstName}
                        onChange={(e) => this.setState({ firstName: e.target.value })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Last Name:</div>
                    <input data-lpignore="true" className="form-control" value={this.state.lastName}
                        onChange={(e) => this.setState({ lastName: e.target.value })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Email:</div>
                    <input data-lpignore="true" type="email" className="form-control" value={this.state.email}
                        onChange={(e) => this.setState({ email: e.target.value })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Username:</div>
                    <input data-lpignore="true" className="form-control" value={this.state.username}
                        onChange={(e) => this.setState({ username: e.target.value })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Password:</div>
                    <input data-lpignore="true" className="form-control" value={this.state.password}
                        onChange={(e) => this.setState({ password: e.target.value })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Google SSO ID:</div>
                    <input data-lpignore="true" className="form-control" value={this.state.googleSSOId}
                        onChange={(e) => this.setState({ googleSSOId: e.target.value })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Clever User ID:</div>
                    <input data-lpignore="true" className="form-control" value={this.state.cleverUserId}
                        onChange={(e) => this.setState({ cleverUserId: e.target.value })} />
                </div>
                {this.renderCleverInputFields()}
                <div className="inputContainer">
                    <div className='inputLabel'>Grade Level:</div>
                    <ReactSelect name="gradeLevel" value={this.state.gradeLevel} clearable={false}
                        options={this.getGradeLevelOptions()} onChange={(p) => this.setState({ gradeLevel: p })} />
                </div>
                <div className="inputContainer">
                    <div className='inputLabel'>Role:</div>
                    <ReactSelect name="role" value={this.state.role} clearable={false}
                        options={this.getRoleOptions()} onChange={this.setRole} />
                </div>
                {this.renderTeacherInputFields()}
                <div className="inputContainer">
                    <div className='inputLabel'>Is Primary Org?:</div>
                    <input data-lpignore="true" type="checkbox" className="form-control" value={this.state.isPrimaryAdmin}
                        onChange={() => this.setState({ isPrimaryAdmin: !this.state.isPrimaryAdmin })} />
                </div>
                {this.renderUpgradeCodeInputFields()}
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="addNewAdminModal">
                <Modal headerText="Add Admin" ref="modal">
                    <form onSubmit={this.handleSubmit}>
                        {this.renderInputFields()}
                        <div className='btnContainer'>
                            <button className='btn btn-primary' type='submit'>Submit</button>
                        </div>
                    </form>
                </Modal>
            </div>
        )
    }

    componentDidMount() {
        this.setStudentListOptions()
        this.setProduct()
        this.setRole()
    }
};

var ADMIN_ROLE = 'adminRole'
var DISTRICT_ADMIN_ROLE = 'districtAdminRole'
var TEACHER_ROLE = 'teacherRole'

var REQUIRED_FIELDS = ['firstName', 'lastName', 'email', 'username', 'password', 'role']
var ALL_GRADES = ["PK", "K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "Mixed"] 

AddNewAdminModal.propTypes = StrictPropTypes({
    addStudentLists: PropTypes.func,
    studentLists: PropTypes.array,
    effectiveUserID: PropTypes.number,
    schoolOrg: PropTypes.object,
    districtOrg: PropTypes.object,
});

module.exports = AddNewAdminModal;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/AddNewAdminModal.js